import PropTypes from 'prop-types';
import React from 'react';
import Recaptcha from 'common/components/recaptcha';
import { translate } from 'common/localization';

class SubscribeInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      input: '',
      recaptchaActive: false,
    };

    this.handleSubscribe = this.handleSubscribe.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEmailInput = this.handleEmailInput.bind(this);
    this.activateRecaptcha = this.activateRecaptcha.bind(this);
    this.focusInput = this.focusInput.bind(this);
  }

  activateRecaptcha() {
    this.setState({
      recaptchaActive: true,
    });
  }

  componentDidMount() {
    BC.sub('coupon.banner.email.error', this.focusInput);
  }

  componentWillUnmount() {
    BC.unsub('coupon.banner.email.error', this.focusInput);
  }

  focusInput() {
    this.inputRef && this.inputRef.focus();
  }

  handleSubscribe(recaptchaResponse) {
    this.props.onSubscribe(this.state.input, recaptchaResponse);
  }

  handleSubmit() {
    if (this.recaptchaElementRef) {
      this.recaptchaElementRef.handleSubmit();
    }
  }

  handleEmailInput(event) {
    event.persist();

    this.setState(
      {
        input: event.target.value,
      },
    );
  }

  render() {
    const { recaptchaActive } = this.state;
    const { error } = this.props;
    const label = translate('label.coupon.banner.email');
    const buttonText = translate('label.coupon.banner.submit');

    return (
      <div id="coupon-input-container" className="coupon-banner__input-container">
        {
          recaptchaActive &&
          <Recaptcha
            callback={this.handleSubscribe}
            elementId="coupon-recaptcha"
            isInvisible
            ref={(element) => {
              this.recaptchaElementRef = element;
            }}
          />
        }
        <label className="coupon-banner__input-label" htmlFor="coupon-banner-input">{label}</label>
        <div>
          <input
            aria-describedby="coupon-banner-description"
            id="coupon-banner-input"
            value={this.state.input}
            onChange={this.handleEmailInput}
            className={`coupon-banner__input ${error && error.description ? 'is-invalid' : ''}`}
            type="text"
            onFocus={this.activateRecaptcha}
            ref={element => this.inputRef = element}
          />
          {error && error.description && (
            <span className="invalid-feedback">
              {error.description}
            </span>
          )}
          <button
            className="btn btn-primary coupon-banner__input-button"
            onClick={this.handleSubmit}
          >
            {buttonText}
          </button>
        </div>
      </div>
    );
  }
}

SubscribeInput.propsTypes = {
  onSubscribe: PropTypes.func,
};

export default SubscribeInput;
